import React, { forwardRef } from "react";
import { TextField } from "@material-ui/core";
import ErrorValidation from "../../../ErrorValidation";
import useStyles from "./styles";

const InputNumberField = (props, ref) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <TextField
        autoComplete="off"
        {...props}
        // {...register}
        inputRef={ref}
        onBlur={props.onBlur}
        value={props?.value || props?.companyContactNumber}
        variant="outlined"
        inputProps={{ "data-testid": "input-change", min: 0 }}
        autofocus
        disabled={props.disabled}
        error={props.error ? true : false}
        InputLabelProps={{
          shrink: true,
          className: classes.inputLabels
        }}
        fullWidth={true}
        color="secondary"
        InputProps={{
          classes: {
            input: classes.inputBox
          }
        }}
      />

      {props.error && <ErrorValidation error={props.error} />}
    </div>
  );
};

export default forwardRef(InputNumberField);
